import axios from '@/http'
//

//获取导航菜单列表
export function getNav() {
    return axios({
        url: '/api/personal-center/get-nav',
        method: 'GET',
    })
}

// 我的资源-获取我的资源媒体类型列表
export function getResourceMediaTypeList() {
    return axios({
        url: 'api/personal-center/get-resource-media-type-list',
        method: 'GET',
    })
}

// 获取科目层级
export function getSubjectbyId(data) {
    return axios({
        url: '/api/subject/get-subjects-by-course-id',
        method: 'GET',
        params: data
    })
}
// 获取学科
export function getSubject(data) {
    return axios({
        url: '/api/teacher-subject/get-teacher-subjects',
        method: 'GET',
        params: data
    })
}
// 获取年级
export function getGrad(data) {
    return axios({
        url: '/api/teacher-subject/get-second-subjects',
        method: 'GET',
        params: data
    })
}
// 获取章节
export function getSection(data) {
    return axios({
        url: '/api/teacher-subject/get-third-subjects',
        method: 'GET',
        params: data
    })
}

// 获取课程
export function getCourse(data) {
    return axios({
        url: '/api/teacher-subject/get-classes-courses',
        method: 'GET',
        params: data
    })
}

// 获取课程列表
export function getAkdmOrClassesCourse(data) {
    return axios({
        url: '/api/teacher-subject/get-akdm-or-classes-courses', // 有自定义课 // 2020/4/1 新
        method: 'GET',
        params: data
    })
}


// 我的资源
// 获取学科
export function myResourcePage(data) {
    return axios({
        url: '/api/personal-center/my-resource-page',
        method: 'GET',
        params: data
    })
}
export function answerCount(data) {
    return axios({
        url: '/api/teacher-index/get-subject-question-not-answer-count',
        method: 'POST',
        data
    })
}
export function teacherQuestionList(data) {
    return axios({
        url: '/api/personal-center/teacher-question-list',
        method: 'GET',
        params: data
    })
}
//查看我的习题
export function teacherGetQuestion(data) {
    return axios({
        url: '/api/personal-center/teacher-get-question',
        method: 'GET',
        params: data
    })
}
//删除我的习题
export function teacherDeleteQuestions(data) {
    return axios({
        url: '/api/personal-center/teacher-delete-questions',
        method: 'POST',
        data
    })
}
//删除我的资源
export function delTeacherResources(data) {
    return axios({
        url: '/api/resource/del-teacher-resources',
        method: 'POST',
        data
    })
}
//修改我的资源
export function updateResourceTitle(data) {
    return axios({
        url: '/api/resource/update-resource-title',
        method: 'GET',
        params: data
    })
}

//我的资源-配置课时
export function updateResources(data) {
    return axios({
        url: '/api/resource/update-resources-info',
        method: 'POST',
        data
    })
}

//班级管理
//班级管理-获取班级学生列表
export function getClassStudents(data) {
    return axios({
        url: '/api/personal-center/get-class-students',
        method: 'GET',
        params: data
    })
}

//班级管理-获取学科列表
export function getRootSubject() {
    return axios({
        url: '/api/subject/get-root-subject',
        method: 'GET',
    })
}

//

//班级管理-保存所带学科
export function addTeacherSubjects(data) {
    return axios({
        url: '/api/teacher-subject/add-teacher-subjects',
        method: 'POST',
        data
    })
}

//班级管理-获取未选班级列表
export function getTakeOutAllClasses(data) {
    return axios({
        url: '/api/personal-center/get-all-classes-take-out-teacher-classes',
        method: 'GET',
        params: data
    })
}

//获取学科列表
export function getTeacherSubjects(data) {
    return axios({
        url: '/api/teacher-subject/get-teacher-subjects',
        method: 'GET',
        params: data
    })
}
//获取章列表
export function getThirdSubjects(data) {
    return axios({
        url: '/api/teacher-subject/get-third-subjects',
        method: 'GET',
        params: data
    })
}
//获取班级列表
export function getAllClasses(data) {
    return axios({
        url: '/api/personal-center/get-all-subject-teacher-classes',
        method: 'GET',
        params: data
    })
}

//获取班级列表
export function getNotSelectClass(data) {
    return axios({
        url: '/api/personal-center/get-all-classes-take-out-teacher-classes',
        method: 'GET',
        params: data
    })
}

//班级管理-编辑班级分组
export function manageTeacherClasses(data) {
    return axios({
        url: '/api/personal-center/manage-teacher-classes',
        method: 'POST',
        data
    })
}

//获取班级分组
export function getClassesGroup(data) {
    return axios({
        url: '/api/personal-center/get-teacher-classes-group',
        method: 'GET',
        params: data
    })
}

//班级管理-获取班级未分组的学生列表
export function getClassesNoGroup(data) {
    return axios({
        url: '/api/personal-center/get-classes-no-group-student',
        method: 'GET',
        params: data
    })
}

//班级管理-获取班级详情
export function getTeacherClassesBySubject(data) {
    return axios({
        url: '/api/personal-center/get-teacher-classes-by-subject',
        method: 'GET',
        params: data
    })
}

//班级管理-获取基础信息
export function classManage() {
    return axios({
        url: '/api/personal-center/class-manage',
        method: 'GET',
    })
}

//班级管理-新增班级分组
export function addStudentClassesGroup(data) {
    return axios({
        url: '/api/personal-center/add-student-classes-group',
        method: 'POST',
        data
    })
}

//班级管理-编辑班级分组
export function manageStudentClassesGroup(data) {
    return axios({
        url: '/api/personal-center/manage-student-classes-group',
        method: 'POST',
        data
    })
}

//班级管理-删除班级分组
export function delStudentClassesGroup(data) {
    return axios({
        url: '/api/personal-center/del-student-classes-group',
        method: 'GET',
        params: data
    })
}

//班级管理-重置学生密码
export function resetStudentsPassword(data) {
    return axios({
        url: '/api/personal-center/reset-students-password',
        method: 'POST',
        data
    })
}

//问答中心
//获取问答中心列表
export function getQuestionPage(data) {
    return axios({
        url: '/api/subject-question/get-teacher-subject-question-page',
        method: 'GET',
        params: data
    })
}

//问答中心-老师回答课堂问题
export function answerSubjectQuestion(data) {
    return axios({
        url: '/api/subject-question/answer-subject-question',
        method: 'POST',
        data
    })
}

//问答中心-删除问答记录
export function delSubjectQuestion(data) {
    return axios({
        url: '/api/subject-question/del-subject-question',
        method: 'GET',
        params: data
    })
}

//获取老师所带班级列表
export function getTeacherClasses(data) {
    return axios({
        url: '/api/subject-question/get-teacher-classes',
        method: 'POST',
        data
    })
}
//问答中心-获取问答中心问题类型
export function getQuestionTypes(data) {
    return axios({
        url: '/api/subject-question/get-question-types',
        method: 'POST',
        data
    })
}
//我的收藏
//我的收藏-获取我的收藏分页
export function resourceCollectList(data) {
    return axios({
        url: '/api/personal-center/resource-collect-list',
        method: 'GET',
        params: data
    })
}
//我的收藏-获取媒体类型列表
export function getMediaTypeList(data) {
    return axios({
        url: '/api/personal-center/get-media-type-list',
        method: 'GET',
        params: data
    })
}
//我的收藏-删除我的收藏
export function delResourceCollect(data) {
    return axios({
        url: '/api/resource-collect/del-resource-collect',
        method: 'GET',
        params: data
    })
}

//我的收藏-删除我的收藏
export function delResourceCollects(data) {
    return axios({
        url: '/api/resource-collect/del-resource-collects',
        method: 'POST',
        data
    })
}

//我的收藏-查看我的收藏
export function getResourceById(data) {
    return axios({
        url: '/api/resource/get-resource-by-id',
        method: 'GET',
        params: data
    })
}
//系统通知
//系统通知-获取消息类型列表
export function getNoticeTypeList(data) {
    return axios({
        url: '/api/personal-center/get-notice-type-list',
        method: 'GET',
        params: data
    })
}
//系统通知-获取我的消息分页
export function teacherStudyMessage(data) {
    return axios({
        url: '/api/personal-center/teacher-study-message',
        method: 'GET',
        params: data
    })
}

//系统通知-删除消息
export function delNotice(data) {
    return axios({
        url: '/api/notice/del-notice',
        method: 'POST',
        data
    })
}
//系统通知-已读消息
export function setNoticeRead(data) {
    return axios({
        url: '/api/notice/set-notice-read',
        method: 'POST',
        data
    })
}
//系统通知-获取问题反馈类型列表
export function getSuggestType(data) {
    return axios({
        url: '/api/suggest/get-suggest-type',
        method: 'GET',
        params: data
    })
}

//系统通知-获取问题反馈类型列表
export function getNotice(data) {
    return axios({
        url: '/api/notice/get-notice',
        method: 'GET',
        params: data
    })
}


//系统通知-问题反馈
export function teacherStudySuggest(data) {
    return axios({
        url: '/api/personal-center/teacher-study-suggest',
        method: 'GET',
        params: data
    })
}

//系统通知-已读消息
export function saveSuggest(data) {
    return axios({
        url: '/api/suggest/save',
        method: 'POST',
        data
    })
}

//个人中心
//获取个人信息
export function getInformation(data) {
    return axios({
        url: '/api/personal-center/get-information',
        method: 'GET',
        params: data
    })
}
//修改资料
export function updateInformation(data) {
    return axios({
        url: '/api/personal-center/update-information',
        method: 'POST',
        data
    })
}
//修改密码
export function updatePassword(data) {
    return axios({
        url: '/api/personal-center/update-password',
        method: 'POST',
        data
    })
}

//公共资源-获取公共资源页面信息
export function publicResources() {
    return axios({
        url: '/api/personal-center/public-resources',
        method: 'GET',
    })
}

//公共资源-获取公共资源分页
export function getPublicResourcesPages(data) {
    return axios({
        url: '/api/personal-center/get-public-resource-pages',
        method: 'GET',
        params: data
    })
}

//公共资源-获取下级科目列表
export function getSchoolNextSubjects(data) {
    return axios({
        url: '/api/subject/get-school-next-subjects',
        method: 'GET',
        params: data
    })
}

//公共资源-学校协议状态设置成功
export function setRepositoryProtocolStatus(data) {
    return axios({
        url: '/api/protocol/set-repository-protocol-status',
        method: 'GET',
        params: data
    })
}


//消息通知-获取未读消息数量
export function getNotReadCount() {
    return axios({
        url: '/api/notice/get-not-read-count',
        method: 'GET',
    })
}

//获取机构相关配置
export function getOrganization() {
    return axios({
        url: '/api/organization/get-organization',
        method: 'GET',
    })
}

//解绑微信登录
export function unbind(data) {
    return axios({
        url: '/api/wechat-login/unbind',
        method: 'POST',
        data
    })
}

//微信扫码登录-获取二维码Url
export function qrConnect(data) {
    return axios({
        url: '/api/wechat-login/qr-connect',
        method: 'GET',
        params: data
    })
}

//微信扫码登录-检测是否已绑定爱米用户
export function checkBind(data) {
    return axios({
        url: '/api/wechat-login/check-bind',
        method: 'GET',
        params: data
    })
}
//微信扫码登录-微信扫码验证
export function checkWechatAuth(data) {
    return axios({
        url: '/api/wechat-login/auth',
        method: 'GET',
        params: data

    })
}
//微信扫码登录-微信扫码验证
export function wechetRestPsw(data) {
    return axios({
        url: '/api/wechat-login/update-password',
        method: 'POSt',
        data
    })
}

//微信扫码登录-绑定爱米用户
export function wechatBind(data) {
    return axios({
        url: '/api/wechat-login/bind',
        method: 'POST',
        data
    })
}

//解除绑定爱米用户
export function wechatUnbind(data) {
    return axios({
        url: '/api/wechat-login/unbind',
        method: 'POST',
        data
    })
}
export function appletUnbind(data) {
    return axios({
        url: '/api/teacher-applet/unbind',
        method: 'POST',
        data
    })
}

export function appletUpdatePwd(data) {
    return axios({
        url: '/api/teacher-applet/update-password',
        method: 'POST',
        data
    })
}


// 个人中心-我的试卷
//获取试卷列表
export function getExams(data) {
    return axios({
        url: '/api/personal-center-teacher/get-exams',
        method: 'GET',
        params: data
    })
}

// 个人中心-我的试卷
//获取试卷
export function getExam(data) {
    return axios({
        url: '/api/personal-center-teacher/get-exam',
        method: 'GET',
        params: data
    })
}

// 获取答题卡列表
export function getExamCards(data) {
    return axios({
        url: '/api/personal-center-teacher/get-exam-cards',
        method: 'GET',
        params: data
    })
}

// 获取答题卡
export function getExamCard(data) {
    return axios({
        url: '/api/personal-center-teacher/get-exam-card',
        method: 'GET',
        params: data
    })
}

//删除试卷
export function delExam(data) {
    return axios({
        url: '/api/personal-center-teacher/del-exam',
        method: 'POST',
        data
    })
}

//删除答题卡
export function delExamCard(data) {
    return axios({
        url: '/api/personal-center-teacher/del-exam-card',
        method: 'POST',
        data
    })
}
/***************订单详情************************/
//老师端-获取价格（Rahul
export function getPrice() {
    return axios({
        url: '/api/jp-class/get-price',
        method: 'GET',
    })
}

//老师端-教培获取班级列表（Rahul）
export function getJpclasses() {
    return axios({
        url: '/api/jp-class/get-classes',
        method: 'GET',
    })
}
//老师端-教培获取班级列表（Rahul）
export function getPayNotPay(data) {
    return axios({
        url: '/api/jp-class/get-class-students',
        method: 'GET',
        params: data
    })
}
//老师端-班级管理--互动通知（Rahul）
export function updateTeacherClasses(data) {
    return axios({
        url: data.host + '/api/akdm-service/update-teacher-classes',
        method: 'GET',
        params: { token: data.token }
    })
}

// //老师端-获取价格（Rahul
// export function getPrice() {
//     return axios({
//         url: '/api/jp-class/get-price',
//         method: 'GET',
//     })
// }